import { render, staticRenderFns } from "./SampleRequestImageInput.vue?vue&type=template&id=d2fc2b9c&"
import script from "./SampleRequestImageInput.vue?vue&type=script&lang=js&"
export * from "./SampleRequestImageInput.vue?vue&type=script&lang=js&"
import style0 from "./SampleRequestImageInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports